import React, {Fragment, useState, useEffect} from 'react';
import {DateContext, Flex, Card, Icon, Icons, Activities, Duration} from 'components';
import {some, returnNull, moment, noop, shorten, useNamedSelector, usePopup, useInterval, useEvent, usePopups} from 'helpers';
import {store} from 'store';
import css from 'components/activities/timer.module.scss';

const audio = new Audio(require('./funk.mp3'));

export function ActiveTimer() {
  const [state, setState] = useState();
  const {toggle, open, id} = usePopup(ActiveTimerPopup, {className: 'paddingless', ...state});
  const timer = useNamedSelector('calendar.activeTimer');
  const alreadyOpened = some(usePopups(), ({Component, props}) => {
    return props?.id === timer?.activityId && Component === Activities.TimerPopup;
  });

  useEffect(() => {
    if (!state && timer) {
      setState({timer});
    } else if (!state?.opened && !timer) {
      setState();
    }
  }, [timer]);

  useEvent('popupopen', ({ detail }) => {
    if (state && id == detail.id) {
      setState({ timer, opened: true });
    }
  });

  useEvent('popupkilled', ({ detail }) => {
    if (state && id == detail.id && !timer) {
      setState();
    }
  });

  useInterval(() => {
    if (timer.getTime() < 1) {
      store.dispatch({
        type: 'ACTIVITIES_REMOVE_TIMER',
        id: timer.id
      });
      if (!alreadyOpened) {
        audio.play();
        open();
      }
    }
  }, timer ? 1000 : null);

  return state && (
    <Icon
      id={id}
      alert={Boolean(timer)}
      aria-haspopup
      isBlinking={Boolean(timer)}
      name={state?.timer.unit}
      onClick={toggle}
      Sub={Icons.Circle}
    />
  );
}

function ActiveTimerPopup({ popup, timer }) {
  return (
    <DateContext.Provider value={moment.unix(timer.ts)}>
      <Activities.Card
        id={timer.activityId}
        onClick={noop}
        Body={Body}
        popup={popup}
        hideTimer
        ActionMenu={returnNull}
      />
    </DateContext.Provider>
  );
}

function Body({ activity, popup, contextDate }) {
  const [ , updateState ] = useState();
  const timer = useNamedSelector('calendar.timer', { id: activity.id, date: contextDate });
  useInterval(() => updateState({}), timer.isRunning ? 1000 : null);
  return (
    <>
      <Card.Body style={{ width: '18em' }}>
        <Flex className="justified">
          <Card.Text className="is3LinesMax">{ activity.name }</Card.Text>
          <Icon className="secondary" name="close" onClick={popup.close} />
        </Flex>
        <Card.Note className="is3LinesMax">{ shorten(activity.note, { words: 30 }) }</Card.Note>
        <div className={css.time}>
          { (timer.unit == 'stopwatch' || activity.duration > 0) &&
            <b><Duration value={timer.getTime()} forceSeconds /></b>
          }
          { activity.duration > 0 &&
            <Fragment>
              <small>{ timer.unit == 'stopwatch'  ? 'out of' : 'left' }</small>
              <b><Duration value={activity.duration*60} /></b>
            </Fragment>
          }
        </div>
        <Activities.TimerControls activity={activity} timer={timer} contextDate={contextDate} />
      </Card.Body>
      {activity.duration > 0 &&
        <Card.Progress now={timer.getTime()} max={activity.duration * 60} position="above" />
      }
    </>
  );
}
